module.exports = __webpack_public_path__ + "static/media/hp.726fa7e1.jpg";